import { useHistory, useLocation } from "react-router-dom";
import {
  AcademySetupHintState,
  AcademySetupItemKey,
} from "app/components/AcademySetup/items";

/**
 * Reads the router state a checklist action pushed to its destination page.
 * `dismiss` removes only the hint key via history.replace so a refresh cannot
 * resurrect the coachmark; any other state the page carries (e.g. /billing's
 * openCustomersTab) is kept.
 */
export default function useAcademySetupHint(itemKey: AcademySetupItemKey): {
  active: boolean;
  dismiss: () => void;
} {
  const location = useLocation<AcademySetupHintState>();
  const history = useHistory<AcademySetupHintState>();

  const active = location.state?.academySetupHint === itemKey;

  const dismiss = () => {
    // The live entry, not the one this render saw: the coachmark also
    // dismisses on a click on its control, after that control's own handler
    // has run. When the handler navigated (Add new Space → /spaces/new) the
    // hint is already gone with the old entry, and replacing with the
    // rendered location would route the coach straight back.
    const current = history.location;
    if (current.state?.academySetupHint !== itemKey) {
      return;
    }
    const rest: AcademySetupHintState = { ...current.state };
    delete rest.academySetupHint;
    history.replace({
      ...current,
      state: Object.keys(rest).length ? rest : undefined,
    });
  };

  return { active, dismiss };
}
